import { ScrollReveal } from '@podus/ui';
import {
    MdOutlineDashboard,
    MdOutlineCalendarMonth,
    MdOutlineFileUpload,
    MdOutlineNotifications,
    MdOutlineHistory,
    MdOutlineShield,
} from 'react-icons/md';

const features = [
    { icon: MdOutlineDashboard, label: 'Centralized Case\nDashboard' },
    { icon: MdOutlineCalendarMonth, label: 'Scheduling &\nTimeline Tracking' },
    { icon: MdOutlineFileUpload, label: 'Secure Evidence\nUploads' },
    { icon: MdOutlineNotifications, label: 'Real-Time\nNotifications' },
    { icon: MdOutlineHistory, label: 'Case History' },
    { icon: MdOutlineShield, label: 'Secure &\nConfidential' },
];

export default function MultidoorFeatures() {
    return (
        <section className="px-4 pt-12 pb-10 sm:px-8 sm:pt-20 sm:pb-14 lg:px-16 lg:pt-40 lg:pb-16 xl:px-20">
            <div className="relative mx-auto max-w-[1920px] rounded-2xl bg-[#F6F6F6] px-5 py-10 sm:px-10 sm:py-14 lg:px-14 lg:py-16 xl:px-20 xl:py-20">
                {/* Header — pill stacks above heading on mobile, side-by-side at lg+ */}
                <div className="">
                    <ScrollReveal variant="fade-up" duration={700} className="shrink-0">
                        <div className="mb-5 w-[100px] not-[]:inline-flex items-center gap-2 font-extrabold rounded-full bg-white px-4 py-2 text-[13px] text-[#0D1615]">
                            <span className="h-1.5 w-1.5 rounded-full bg-primary " />
                            Features
                        </div>
                    </ScrollReveal>

                    <ScrollReveal variant="fade-up" delay={150} duration={800} className="lg:flex lg:justify-end">
                        <h2 className="text-[clamp(1.5rem,3vw,2.75rem)] font-bold leading-[1.2] text-secondary lg:max-w-[600px] lg:text-right">
                            Everything You Need to <span className="block lg:inline">Manage and Resolve Cases</span>
                        </h2>
                    </ScrollReveal>
                </div>

                {/* Feature tiles */}
                <div className="mt-10 grid grid-cols-2 gap-x-4 gap-y-8 sm:mt-12 sm:grid-cols-3 sm:gap-y-10 mt-16 lg:grid-cols-[repeat(6,auto)] lg:justify-between lg:gap-x-0">
                    {features.map((feature, i) => {
                        const Icon = feature.icon;
                        return (
                            <ScrollReveal key={feature.label} variant="fade-up" delay={i * 80} duration={700}>
                                <div className="flex flex-col items-center text-center">
                                    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#DDDDDA] text-secondary sm:h-16 sm:w-16 lg:h-20 lg:w-20">
                                        <Icon size={26} color="#797C7F" />
                                    </div>
                                    <p className="mt-3 whitespace-pre-line text-[clamp(0.8125rem,0.95vw,0.9375rem)] font-medium leading-tight text-secondary sm:mt-4">
                                        {feature.label}
                                    </p>
                                </div>
                            </ScrollReveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
